import {
  withTranslation,
} from 'react-i18next';

import RegattaChecksSectionView from './RegattaChecksSectionView';

const TranslatedComponent = withTranslation()(RegattaChecksSectionView);

const Component = TranslatedComponent;

export default Component;
